/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo core
--------------------------------------------------------------------------------

*/

"use strict";

; (function ($) {

    $.fn.getKendoComponent = function (type) {
        var typeName = "";
        try {
            typeName = "kendo" + type.prototype.options.name;
        } catch (error) { }
        if (!typeName) {
            return undefined;
        }
        return this.data(typeName) || undefined;
    }

})(jQuery);

; (function ($) {

    var kendo = window.kendo;
    if (!kendo || kendo.updated) return;

    var support = kendo.support,
        browser = support.browser,
        isLocalStorage = false,
        ERROR = 1,
        WARNING = 2,
        INFO = 3,
        LOG = 4,
        OUTPUT_ALERTS = "alerts",
        OUTPUT_CONSOLE = "console",
        OUTPUT_NONE = "none",
        Class = kendo.Class,
        Observable = kendo.Observable,
        Widget = kendo.ui.Widget,
        defaultWidgetOptions = {
            debugLevel: WARNING,
            fullDates: false, // set to true to see also dates in console messages
            outputType: OUTPUT_CONSOLE // OUTPUT_ALERTS, OUTPUT_NONE
        },
        placeholderSupported = support.placeholder,
        PLACEHOLDER = "placeholder",
        ATTR_INVALID = "aria-invalid",
        HIDDEN = "hidden",
        INVISIBLE = "invisible",
        DISABLED = "k-state-disabled",
        DEFAULT = "k-state-default",
        HOVER = "k-state-hover",
        ID = "id",
        AVATAR = "avatar",
        mainWidgetRoleNames = [
            "autocomplete",
            "button",
            // "calendar",
            "checkbox",
            "combobox",
            "datepicker",
            "datetimepicker",
            "dropdowndatepicker",
            // "draggable",
            "dropdownlist",
            // "droptarget",
            // "droptargetarea",
            "grid",
            "menu",
            "panelbar",
            "multiselect",
            "numerictextbox",
            "password",
            "popup",
            "radiobutton",
            "rangeslider",
            "slider",
            "tabstrip",
            "textbox",
            "textarea",
            "timepicker",
            "treeview",
            "upload",
            // "validator",
            "window"
        ],
        ATTR_TITLE = "title",
        // description UI type data
        ATTR_DESCR_UI_TYPE = "descrUi",
        // description UI types
        DESCR_UI_TITLE = "title",
        DESCR_UI_TOOLTIP = "tooltip",
        DESCR_UI_ICON = "icon",
        // default description icon CSS class
        DESCR_ICON = "title-icon",
        // validation UI type data
        ATTR_VAL_UI_TYPE = "valUi",
        // validation UI types
        VAL_UI_TITLE = "title",
        VAL_UI_TOOLTIP = "tooltip",
        VAL_UI_ICON = "icon",
        // icon classes on widgets
        WITH_DESCR_ICON = "with-description-icon",
        DEFAULT_DURATION = 200,
        WIDGET_DESCRIPTION_TEMPLATE_PREFIX = "widget_descr_",
        RWD = "data-rwd",
        RWD_SIZES = "data-rwd-sizes",
        RWD_CLASSES = "data-rwd-classes",
        RWD_UPDATE_ALSO = "data-rwd-update-also",
        defaultUpdatedWidgetOptions = {
            // description icon CSS class
            descriptionIconCssClass: DESCR_ICON,
            // templates for tooltip descriptions
            templates: {
                widget_descr_title: "#=message#",
                widget_descr_tooltip: "<span>#=message#</span>",
                widget_descr_icon: '<span class="k-icon #=descrIconClass#" data-tooltip-offset="15"></span>'
            }
        },
        FORMAT_CURRENCY = "c",
        FORMAT_ORI_CURRENCY = "oc",
        COMMA = ",",
        DOT = ".";

    // #region JS fixes

    // same used in ori.js
    // TODO : maybe we should move this into separate JS file
    (function () {

        // Oriflame non-standard extension
        if (!("formatWith" in String.prototype)) {
            String.prototype.formatWith = function (obj) {
                var str = this,
                    type = Object.prototype.toString.call(obj).replace("object ", ""),
                    i = 0,
                    l = arguments.length,
                    r;
                if (type === "[Object]" && l === 1) {
                    for (var prop in obj) {
                        r = new RegExp("\{" + prop + "\}", "g");
                        str = str.replace(r, obj[prop]);
                    }
                } else {
                    for (; i < l; i++) {
                        r = new RegExp("\\{" + i + "\\}", "gi");
                        str = str.replace(r, arguments[i]);
                    }
                }
                return str;
            };
        }

        // older IE console fixes
        var methods = [
            "log", "info", "warn", "error",
            "assert", "dir", "clear", "profile", "profileEnd"
        ];
        if (!window.console) {
            console = window.console = {};
            methods.forEach(function (method) {
                console[method] = function () { };
            });
        } else if (Function.prototype.bind && typeof console.log == "object") {
            methods.forEach(function (method) {
                console[method] = this.bind(console[method], console);
            }, Function.prototype.call);
        }

    })();

    // #endregion JS fixes

    // #region storage for debug functionality

    try {
        isLocalStorage = Boolean(window.localStorage);
    } catch (error) { }

    var getStoredSetting = isLocalStorage ?
        function (name) { return localStorage.getItem(name); } :
        function (name) { return $.cookie(name); };

    // #endregion storage for debug functionality

    // #region global Kendo extensions

    /**
     * Overide placeholder support. Some browser sniffing here, as the placeholder
     * support in kendo is not accurate regarding redesign possibilities.
     * In IE 10+ the support should be sufficient, but the placeholder is hidden
     * on focus, so for now marked as unsupported at all.
     */
    if (
        (browser.opera && browser.version < 15) ||
        (browser.msie /* && browser.version < 11 */)
    ) {
        support.placeholder = false;
        placeholderSupported = false;
    }

    // This object must be set up before extending with ASP.NET validations script
    // ( kendo.aspnetmvc.js ). Now that we don't use the original validator script,
    // it has to be defined here.
    if (!kendo.ui.validator) kendo.ui.validator = { rules: {}, messages: {} };

    /**
     * Similar to kendo.widgetInstace with ability to provide roles filter for
     * searched objects.
     * @returns Kendo widget instance or undefined when not found.
     */
    function widgetInstanceEx(element, roles) {
        roles = roles || kendo.ui.roles;
        var $element = $(element),
            widget = $element.length ? roles[$element.data(kendo.ns + "role")] : undefined;
        if (!widget) {
            return undefined;
        }
        return $element.data("kendo" + widget.fn.options.prefix + widget.fn.options.name);
    };

    /**
     * Helper function to set kendo.ui.mainWidgetRoles and return the created object.
     */
    function getMainWidgetRoles() {
        var suite = kendo.ui;
        if (!suite.mainWidgetRoles) {
            var names = mainWidgetRoleNames;
            suite.mainWidgetRoles = {};
            for (var i = 0; i < names.length; i++)
                if (typeof suite.roles[names[i]] == "function")
                    suite.mainWidgetRoles[names[i]] = suite.roles[names[i]];
        }
        return suite.mainWidgetRoles;
    }

    /**
     * Helper function to find widget instance object in specified element's data.
     * Returns first available object in element or subelements, or null.
     * We use here the kendo.ui.mainWidgetRoles custom defined filter for main widgets.
     * @param element Element to start search on.
     * @param skipSubElements When true, the search for instance on sub-elements is skipped.
     * @param roles Only main widget roles / types are searched for by default. That can be
     * overridden by this parameter.
     * @returns Kendo widget instance or undefined when not found.
     */
    function findWidgetInstance(element, skipSubElements, roles) {
        var $element = $(element);
        if (!$element.length) {
            return undefined;
        }
        roles = roles || getMainWidgetRoles();
        var instance = kendo.widgetInstanceEx($element, roles);
        if (instance || skipSubElements) {
            return instance;
        }
        // Search through subitems on which the data could be placed.
        // For more complex components these are not only inputs.
        $element.find("*").each(function () {
            instance = kendo.widgetInstanceEx(this, roles);
            if (instance) {
                return false;
            }
        });
        return instance;
    };

    /**
     * Helper for getting input value in a "standard" way considering input type.
     */
    function getInputValue(input) {
        var $input = $(input);
        var $checkedInput = $input.filter(":checked");
        if ($checkedInput.length === 1) {
            return $checkedInput.val();
        }
        return $input.is(":checkbox") ? $input.prop("checked") : $input.val();
    }

    /**
     * Tries to find nearest element in DOM tree corresponding to the selector.
     * The search starts at the start element, which can be selector or $-targetted object.
     * TODO : make these extensions of jQuery
     */
    function nearest(start, selector) {
        var $start = $(start);
        if (!$start.length) return $start;
        var $found = $start.find(selector);
        if ($found.length) return $($found[0]);
        $found = $start.prevAll(selector);
        if ($found.length) return $($found[0]);
        $found = $start.nextAll(selector);
        if ($found.length) return $($found[0]);
        $found = $start.parent();
        return $found.length ? kendo.nearest($found, selector) : $found;
    }

    function isChildOf(element, parent) {
        var $element = $(element),
            $parent = $(parent);
        if ($parent.is($element)) return true;
        if ($element.closest($parent).length > 0) return true;
        return false;
    }

    function describeElement(element) {
        var $element = $(element),
            domElement = $element.get(0);
        if (!domElement) return "";
        var tag = domElement.nodeName.toLowerCase(),
            type = $element.attr("type") || "",
            value = type ? (
                $element.is("[type=checkbox]") ?
                    $element.is(":checked").toString() :
                    $element.val().toString()
            ) : "",
            id = $element.attr("id") || "",
            name = $element.attr("name") || "",
            cssClass = $element.attr("class") || "";
        if (type) type = "[" + type + "]";
        if (id === name) name = "";
        if (id) id = "#" + id;
        if (name) name = "[" + name + "]";
        if (cssClass) cssClass = "." + cssClass.split(" ").join(".");
        if (value) value = "{" + value + "}";
        return tag + type + name + id + cssClass + value;
    }

    /**
     * Returns a set of options for the first targeted element based on specified
     * prefix.
     */
    function elementOptions(element, prefix, defaults) {
        var $element = $(element),
            data = $element.data(),
            options = $.extend({}, defaults),
            pref = $.trim(prefix),
            prefLength = pref.length;
        if (!$element.length || !data || !prefLength) return options;
        for (var key in data) {
            if (!data.hasOwnProperty(key)) continue;
            // key must contain prefix + something to be used here
            if (key.indexOf(pref) !== 0 || key.length <= prefLength) continue;
            var option = key.substr(prefLength, 1).toLowerCase() + key.substr(prefLength + 1);
            options[option] = data[key];
        }
        return options;
    }

    /**
     * Returns default updated widget options extended by provided
     * custom options.
     */
    function getUpdatedWidgetOptions(options) {
        return $.extend(true, {}, defaultUpdatedWidgetOptions, options);
    }

    /**
     * Needed for validateInput() method in Validator etc.
     */
    function decode(value) {
        if (!value) return value;
        return value
            .replace(/&amp/g, "&amp;")
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">");
    }

    /**
     * Helper function to format date in following format :
     * [YYYY-MM-DD ]hh:mm:ss.xxx
     */
    function formatDate(d, fullDate) {
        if (!(d instanceof Date)) return "";
        if (!fullDate) fullDate = false;
        var fd = "",
            x = "";
        if (fullDate) {
            fd += d.getFullYear() + "-";
            x = "" + (d.getMonth() + 1);
            if (x.length < 2) x = "0" + x;
            fd += x + "-";
            x = "" + d.getDate();
            if (x.length < 2) x = "0" + x;
            fd += x + " ";
        }
        x = "" + d.getHours();
        if (x.length < 2) x = "0" + x;
        fd += x + ":";
        x = "" + d.getMinutes();
        if (x.length < 2) x = "0" + x;
        fd += x + ":";
        x = "" + d.getSeconds();
        if (x.length < 2) x = "0" + x;
        fd += x + ".";
        x = "" + d.getMilliseconds();
        while (x.length < 3) x = "0" + x;
        fd += x;
        return fd;
    }

    /**
     * To apply invalid class also to a wrapper we have to find it.
     */
    function findWrapper(input) {
        var $input = $(input);
        if ($input.is(".k-widget")) return $input;
        var $parent = $input.parent();
        return $parent.length ? findWrapper($parent) : null;
    };

    /**
     * Attempt to have some generic boolean parsing routine in Kendo.
     */
    function parseBoolean(value) {
        if (typeof value == "boolean") return value;
        // null, undefined, zero
        if (!value) return false;
        var x = $.trim(value.toString()).toLowerCase();
        // empty string
        if (x === "") return false;
        // explicit textual representations
        if (x === "true") return true;
        if (x === "false") return false;
        // check for non-zero number textual representation
        x = undefined;
        try { x = kendo.parseFloat(value); } catch (error) { }
        if (typeof x == "number" && !isNaN(x)) return x ? true : false;
        try { x = parseFloat(value, 10); } catch (error) { }
        if (typeof x == "number" && !isNaN(x)) return x ? true : false;
        // otherwise consider the value to be set, thus return true
        return true;
    }

    /**
     * Creates a placeholder label under the main visible input in older browsers.
     * This is not needed for new browsers where placeholder attribute is supported.
     * Exception here is Opera, which by now doesn't support placeholder formatting,
     * so we manage it like in older browsers with generated helper label and
     * remove the placeholder attribute.
     */
    function placeholderLabel() {
        var self = this;
        self.info("Placeholder supported : %s", placeholderSupported);
        if (placeholderSupported) return;
        var CLASSNAME = "placeholder",
            $wrapper = self.wrapper,
            $element = self.element,
            $input = $(self.input),
            id = $element.attr(ID),
            $placeholder = $wrapper.find("." + CLASSNAME);
        self.options.placeholder = self.options.placeholder || $element.attr("placeholder") || "";
        if (!$placeholder.length) {
            self.info(
                "Creating fake placeholder for %s with text '%s' ...",
                describeElement($wrapper), self.options.placeholder
            );
            $placeholder = $("<label />")
                .insertAfter($element)
                .addClass(CLASSNAME)
                .addClass(HIDDEN)
                .attr("unselectable", "on");
        }
        $placeholder
            .attr("tabindex", "-1")
            .html(self.options.placeholder);
        if (id) $placeholder.attr("for", id);
        // remove placeholder when HTML5 placeholder not supported
        $element.removeAttr(PLACEHOLDER);
        $input.removeAttr(PLACEHOLDER);
        self._placeholderElement = $placeholder;
    };

    /**
     * Used when widget value gets changed to display / hide placeholder label
     * in older browsers.
     */
    function placeholderVisibility(show) {
        var self = this,
            $placeholder = self._placeholderElement;
        if (placeholderSupported || !self.options.placeholder) {
            if ($placeholder && $placeholder.length) $placeholder.addClass(HIDDEN);
            return;
        }
        var $input = $placeholder.parent().find(".k-input"),
            w = $input.width(),
            h = $input.height(),
            v = self.value();
        if (typeof show == "undefined")
            show = (v == null || kendo.toString(v).length === 0);
        self.info((show ? "Showing" : "Hiding") + " placeholder, size %dx%d ...", w, h);
        $placeholder
            .toggleClass(HIDDEN, !show)
            .width(w)
            .height(h);
    }

    /**
     * Appends placeholder update to old keyboard event handler.
     */
    function updateKeyEventHandler(controlPrototype, methodName) {
        var oldMethod = controlPrototype[methodName];
        if (typeof oldMethod != "function") return;
        controlPrototype[methodName] = function (event) {
            var self = this,
                $input = self.wrapper.is(".k-combobox") ?
                    self.wrapper.find("input:visible") :
                    self.element;
            oldMethod.call(self, event);
            if (!$input.length || typeof self._placeholder != "function") return;
            // input's value gets updated after a while, so using timeout
            window.setTimeout(function () {
                var val = $input.val();
                self._placeholder(!val);
                if (typeof self.info != "function") return;
                self.info(
                    "%s, value : '%s'\ninput : %s, active input : %s",
                    event.type, val, describeElement($input),
                    describeElement(document.activeElement)
                );
            }, 0);
        };
    }

    /**
     * There is additional subwrapper on which the states are applied by default,
     * but we want them on the main widget wrapper.
     */
    function moveStateStylesToWrapper() {
        var self = this;
        if (self._inputWrapper) self._inputWrapper.removeClass(DEFAULT);
        self.wrapper.addClass(DEFAULT);
    }

    /**
     * Some compomnents like window keep custom styles applied only to original element,
     * but we want them on the main widget wrapper.
     */
    function moveCustomStylesToWrapper() {
        var self = this,
            customStyles = (self.element.attr("class") || "").split(" ");

        $.each(customStyles, function (index, value) {
            if (!customStyles.hasOwnProperty(index)) {
                return;
            }
            // Invisible is added to list of classes that should not be moved because it have special meaning in checkbox
            if (value === HIDDEN || value === INVISIBLE || value.substring(0, 2) === "k-") {
                return;
            }
            // Some of the components copy all styles on original markup element (input) to wrapper.
            // We want the existing "js-" prefixed classes to stay on the original element,
            // because this is what you want functionally in most cases like for finding
            // the component instance data, validation data & others.
            // So we clear here the possible duplicate from wrapper.
            // TODO: this method should be called better, like normalize CSS classes or so
            if (value.substring(0, 3) === "js-") {
                self.wrapper.removeClass(value);
                return;
            }

            self.element.removeClass(value);
            self.wrapper.addClass(value);
        });
    }

    /**
     * Some compomnents like window keep custom styles applied only to original element,
     * but we want them on the main widget wrapper.
     */
    function moveRwdDataToWrapper() {
        var self = this,
            rwdDataKeys = [RWD, RWD_SIZES, RWD_CLASSES, RWD_UPDATE_ALSO];
        for (var i = 0; i < rwdDataKeys.length; i++) {
            var value = self.element.attr(rwdDataKeys[i]);
            if (!value) continue;
            self.element.removeAttr(rwdDataKeys[i]);
            self.wrapper.attr(rwdDataKeys[i], value);
        }
    }

    /**
     * Apply states rather on main wrapper than on subwrapper.
     */
    function toggleHoverOnWrapper(event) {
        var $wrapper = kendo.findWrapper(this);
        if ($wrapper)
            $wrapper.toggleClass(HOVER, event.type === "mouseenter");
    }

    /**
     * Make sure clicking on label focuses corresponding control in case original
     * element is hidden after widget is initialized.
     */
    function activateLabel() {
        var self = this,
            $element = $(self.element);
        if (!$element.length || !$element.is(":input:hidden") || $element.is("button")) return;
        var $label = $('label[for="' + $element.attr("name") + '"]'),
            opt = self.options || {},
            NS = opt.name ? (".kendo" + opt.name) : "";
        $label.on("click" + NS, function () {
            var $wrapper = kendo.findWrapper($element),
                $kendoInput = $(".k-input:visible", $wrapper);
            $kendoInput.focus();
        });
    }

    // add new events if present in update config
    function appendEvents(events) {
        if (!$.isArray(events)) return;
        var self = this;
        if (!$.isArray(self.events)) self.events = [];
        for (var i = 0; i < events.length; i++) {
            var event = events[i];
            if (self.events.indexOf(event) < 0) self.events.push(event);
        }
    }

    /**
     * Placeholder functionality update.
     */
    function updatePlaceholderLogic(widget) {
        if (!widget) return;
        var wp = widget.prototype;
        wp._placeholder = placeholderVisibility;
        // generates fake placeholder when needed
        wp._placeholderLabel = placeholderLabel;
        // update keyup & keydown handlers with fake placeholder checking
        if (!placeholderSupported) {
            updateKeyEventHandler(wp, "_keyup");
            updateKeyEventHandler(wp, "_keydown");
        }
        // Placeholder label must exist already before old init() ends,
        // so we try to call it just after the wrapper gets generated.
        var oldWrapper = widget.fn ? widget.fn._wrapper : wp._wrapper;
        if (typeof oldWrapper != "function") return;
        wp._wrapper = function () {
            var self = this;
            oldWrapper.call(self);
            self._placeholderLabel();
        };
    }

    /**
     * Moving functionality from subwrapper to main widget wrapper.
     */
    function moveFunctionalityToWrapper(widget) {
        var oldEnable = widget.fn.enable,
            wp = widget.prototype,
            opt = wp.options || {},
            NS = opt.name ? (".kendo" + opt.name) : "";
        if ($.isFunction(wp._toggleHover))
            wp._toggleHover = toggleHoverOnWrapper;
        // update enable setter
        wp.enable = function (enable) {
            var self = this,
                HOVEREVENTS = "mouseenter" + NS + " mouseleave" + NS;
            oldEnable.call(self, enable);
            if (self._inputWrapper)
                self._inputWrapper
                    .off(HOVEREVENTS)
                    .removeClass(DEFAULT)
                    .removeClass(DISABLED);
            if (!enable)
                self.wrapper
                    .removeClass(DEFAULT)
                    .addClass(DISABLED);
            else {
                self.wrapper
                    .addClass(DEFAULT)
                    .removeClass(DISABLED);
                if ($.isFunction(self._toggleHover))
                    self.wrapper.on(HOVEREVENTS, self._toggleHover);
            }
        };
    }

    /**
     * Used to extend existing Kendo widget in a minimal way.
     * Only checks for extended element options and removes the avatar class.
     * Returns new function to be used as updated widget init() method.
     */
    function getGenericInit(widget) {
        var oldInit = widget.fn.init,
            p = widget.prototype,
            cName = p.options.name || "",
            newInit = function (element, options) {
                var self = this,
                    $element = $(element);
                // update options from specifically prefixed data on element
                options = kendo.elementOptions($element, cName.toLowerCase(), options);
                if (options.enabled === undefined)
                    options.enabled = !$element.is("[disabled]");
                // remove avatar class before the wrapper gets created
                $element.removeClass(AVATAR);
                // call original constructor
                oldInit.call(self, element, options);
            };
        return newInit;
    }

    /**
     * Helper method for checking whether the script runs inside an iframe.
     */
    function isIframe() {
        var result = false;
        try {
            result = window.self !== window.top;
        } catch (error) {
            // suppose exception due to crossdomain, than this has to be iframe
            result = true;
        }
        return !!result;
    }

    /**
     * We try to access parent frame. If this is without error, we are probably
     * on the same domain, otherwise crossdomain communication is needed.
     */
    function isCrossDomainIframe() {
        var crossDomain = false;
        try {
            var x = parent.location.href;
        } catch (error) {
            crossDomain = true;
        }
        return !!crossDomain;
    }

    /**
     * Returns client bounding rectangle of given HTML element in current viewport
     * or null.
     */
    function boundingRect(element) {
        if (!element) return null;
        var el = (element instanceof jQuery && element.length) ?
            element[0] : element,
            result = (typeof el.getBoundingClientRect == "function") ?
                el.getBoundingClientRect() : null;
        if (result)
            result = $.extend({}, result, {
                x: {
                    min: result.left,
                    max: result.right
                },
                y: {
                    min: result.top,
                    max: result.bottom
                }
            });
        return result;
    }

    /**
     * Returns true if whole element bounding rectangle is currently visible
     * in current viewport's visible area.
     */
    function isElementInViewport(element, view) {
        var rect = boundingRect(element);
        if (!view) view = window;
        return (
            rect &&
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (view.innerHeight || view.document.documentElement.clientHeight) &&
            rect.right <= (view.innerWidth || view.document.documentElement.clientWidth)
        );
    }

    /**
     * Copied from jQuery code.
     */
    function getWindow(elem) {
        return $.isWindow(elem) ?
            elem :
            elem.nodeType === 9 ?
                elem.defaultView || elem.parentWindow :
                false;
    }

    /**
     * Returns smaller size of either html or body elements in a given axis.
     */
    function getDocSize(doc, axis) {
        if (!doc || !axis) return null;
        var prop = "offset" + (axis === "x" ? "Width" : "Height");
        return Math.min(doc.body[prop], doc.documentElement[prop]);
    }

    /**
     * Returns larger scroll ( content ) size of either html or body elements in a given axis.
     */
    function getDocScrollSize(doc, axis) {
        if (!doc || !axis) return null;
        var prop = "scroll" + (axis === "x" ? "Width" : "Height");
        return Math.max(doc.body[prop], doc.documentElement[prop]);
    }

    /**
     * Returns description object of scrolling capabilities on provided object.
     * @param {} element Can be either string ( selector ), object ( HTML element )
     * or jQuery targetted object.
     */
    function scrollProps(element) {
        if (element === "window") element = window;
        if (element === "document") element = document;
        var $el = $(element);
        if (!$el.length) return null;
        var el = $el[0],
            win = getWindow(el);
        if (win) {
            el = win.document;
            $el = $(el);
        }

        function axisProps(axis) {
            var suffix1 = axis === "x" ? "Width" : "Height",
                suffix2 = axis === "x" ? "Left" : "Top",
                size = win ? getDocSize(el, axis) : $el["offset" + suffix1],
                scrollSize = win ? getDocScrollSize(el, axis) : el["scroll" + suffix1];
            return {
                canScroll: (size < scrollSize),
                size: size,
                scrollSize: scrollSize,
                scroll: $el["scroll" + suffix2]()
            };
        }

        return {
            element: el,
            x: axisProps("x"),
            y: axisProps("y")
        };
    }

    /**
     * Updates .NET JSON result so that property names in the object start
     * with lower case letters.
     */
    function updateJsonResult(data) {
        if (typeof data != "object" || !data) return data;
        var result;
        if ($.isArray(data)) {
            result = [];
            for (var i = 0, l = data.length; i < l; i++)
                result.push(updateJsonResult(data[i]));
        } else {
            result = {};
            for (var key in data)
                if (data.hasOwnProperty(key))
                    result[key.substring(0, 1).toLowerCase() + key.substring(1)] = updateJsonResult(data[key]);
        }
        return result;
    }

    /**
     * Helper method for transferring Ori currency formatting to client, optionally including also
     * double currency. Adds oriCurrency formatting settings to current culture configuration.
     * Want to achieve something like this after JS serialization :
     *
     * oriCurrency : {
     *     pattern : [ "-$n","$n" ],
     *     decimals : 2,
     *     "," : ",",
     *     "." : ".",
     *     groupSize : [ 3 ],
     *     symbol : "$",
     *     format : "c",
     *     doubleCurrency : {
     *         rate : 20.1546,
     *         rounding : { ... }, // TODO : this will not be implemented for now
     *         pattern : [ "-$n","$n" ],
     *         decimals : 2,
     *         "," : ",",
     *         "." : ".",
     *         groupSize : [ 3 ],
     *         symbol : "$",
     *         format : "c"
     *     }
     * }
     */
    function updateOriCurrency(info) {
        if (!info) return;

        function updateSeparators(settings) {
            settings[COMMA] = typeof settings.groupSeparator == "string" ? settings.groupSeparator : "";
            delete (settings.groupSeparator);
            settings[DOT] = typeof settings.decimalSeparator == "string" ? settings.decimalSeparator : ".";
            delete (settings.decimalSeparator);
        }

        function extendInfo(defaultSettings, newSettings) {
            return $.extend(true, {}, defaultSettings, newSettings);
        }

        var numberFormat = kendo.getCulture().numberFormat;
        info = kendo.updateJsonResult(info);
        updateSeparators(info);
        if (info.doubleCurrency) updateSeparators(info.doubleCurrency);

        // extend the default "standard" currency formatting available from the ori culture JS files
        // and store it in a new oriCurrency property - similar to how this works on server
        info = extendInfo(numberFormat.currency, info);
        if (info.doubleCurrency) info.doubleCurrency = extendInfo(numberFormat.currency, info.doubleCurrency);

        // keeping default currency settings intact from how they are transferred from server
        // and rather inserting completely new property for Ori currencies
        numberFormat.oriCurrency = info;
    }

    /**
     * Helper to check the special ori currency format, like "oc", "oc2" etc.
     */
    function getOriCurrencyFormatPrecision(format) {
        var re = new RegExp("^(" + FORMAT_ORI_CURRENCY + ")(\\d*)$", "i");
        return re.exec(format);
    }

    /**
     * Original Kendo function for rounding a value & returning formatted string according to precision.
     */
    function round(value, precision) {
        precision = precision || 0;
        value = value.toString().split("e");
        value = Math.round(+(value[0] + "e" + (value[1] ? (+value[1] + precision) : precision)));
        value = value.toString().split("e");
        value = +(value[0] + "e" + (value[1] ? (+value[1] - precision) : -precision));
        return value.toFixed(precision);
    }

    /**
     * Formats currency with the given settings.
     * Optionally wraps amount & symbol into spans with specific CSS classes.
     */
    function formatWithPattern(pattern, amount, symbol, amountCssClass, symbolCssClass) {
        if (amountCssClass) amount = "<span class='" + amountCssClass + "'>" + amount + "</span>";
        if (symbolCssClass) symbol = "<span class='" + symbolCssClass + "'>" + symbol + "</span>";
        var result = "";
        for (var i = 0, l = pattern.length; i < l; i++) {
            var ch = pattern.charAt(i);
            if (ch === "n") {
                result += amount;
            } else if (ch === "$") {
                result += symbol;
            } else {
                result += ch;
            }
        }
        return result;
    }

    // updated method reference
    var oldToString = kendo.toString;

    /**
     * Special ori currency formatter.
     * @param {} number The currency value ( price ).
     * @param {} format Must be "oc" ( + precision number if overriding default )
     * @param {} culture Optional culture. When empty, current culture will be loaded.
     * Please note that for other than the current culture, the additional ori currency
     * info will probably not be set. When specifying optional CSS classes and current
     * culture should be used, provide undefined or null value for culture parameter.
     * @param {} amountCssClass Optional CSS class for formatting the amount value text.
     * @param {} symbolCssClass Optional CSS class for formatting the currency symbol text.
     * @param {} dcAmountCssClass Same as amountCssClass, but used only when double currency is on.
     * @param {} dcSymbolCssClass Same as symbolCssClass, but used only when double currency is on.
     * @param doubleCurrencyDelimiter The custom delimiter to be used instead of default for double currency, but used only when double currency is on.
     * @returns {} Formatted currency string optionally containing double currency
     * and / or additional CSS formatting classes' spans.
     */
    function formatOriCurrency(
        number, format, culture,
        amountCssClass, symbolCssClass,
        dcAmountCssClass, dcSymbolCssClass,
        doubleCurrencyDelimiter = " / "
    ) {
        if (number == undefined) return "";
        if (!isFinite(number)) return number;

        var formatAndPrecision = getOriCurrencyFormatPrecision(format);
        if (!formatAndPrecision) return oldToString(number, FORMAT_CURRENCY, culture);

        // check for ori currency info in requested culture's settings
        var numberFormat = kendo.getCulture(culture).numberFormat,
            oriCurrency = $.extend(true, {}, numberFormat.currency, numberFormat.oriCurrency),
            customPrecision = formatAndPrecision[2];

        // helper to format a currency value with a particular currency settings
        function formatCurrency(amount, settings, amountCssClass, symbolCssClass) {
            var format = settings.format,
                groupSizes = settings.groupSize,
                groupSize = groupSizes[0],
                groupSeparator = settings[COMMA],
                decimalSeparator = settings[DOT],
                precision = customPrecision ? +customPrecision : settings.decimals,
                symbol = settings.symbol,
                negative = amount < 0,
                pattern = settings.pattern[negative ? 0 : 1],
                integer,
                fraction,
                value = "",
                i, l;

            // standard formatting like "c", don't have to parse custom format mask
            if (!format) {
                amount = round(amount, precision).split(DOT);
                integer = amount[0];
                fraction = amount[1];
                //exclude "-" if amount is negative.
                if (negative) integer = integer.substring(1);
                value = integer;
                l = integer.length;
                // add group separator to the amount if it is long enough
                // TODO : this is the Kendo default logic, doesn't respect multiple group sizes
                if (l >= groupSize) {
                    value = "";
                    for (i = 0; i < l; i++) {
                        if (i > 0 && (l - i) % groupSize === 0) value += groupSeparator;
                        value += integer.charAt(i);
                    }
                }
                if (fraction) value += decimalSeparator + fraction;
                return formatWithPattern(pattern, value, symbol, amountCssClass, symbolCssClass);
            }

            // custom formatting, format contains custom format mask
            // TODO : this part doesn't cover all cases for generic custom format parsing,
            // but rather it is focused rather on formatting currency only + special ori currency cases
            // so no percentages, number scaling with commas, exponential formats etc. here
            var ZERO = "0",
                SHARP = "#",
                LITERAL_REGEXP = /(['][^']*[']?)|(["][^"]*["]?)|([^#0;,.])|(\\,)|(\\.)/g,
                LITERAL_PLACEHOLDER = "?",
                LITERAL_PLACEHOLDER_REGEXP = /\?/g,
                literals = [],
                hasGroups = false,
                GROUP_REGEXP = /\,+(?!\,)/g,
                formatSectionUsed = 0;

            // Replaces literals in format string with placeholders while storing
            // the original literal values in array for later use.
            function replaceLiterals(match) {
                var literal = match;
                if (literal.length > 2)
                    literal = literal.substr(1, literal.length - 2);
                else if (literal.length > 1)
                    literal = literal.substr(1);
                literals.push(literal);
                return LITERAL_PLACEHOLDER;
            }

            // Removes group literal from given format string and
            // sets indicator that group separators are used.
            function replaceGroups() {
                hasGroups = true;
                return "";
            }

            // Custom format string can contain at max. 3 sections separated
            // by semicolons in order positive, negative and zero format.
            // When negativ and / or zero section is missing, positive section is used as a fallback.
            // Returns the proper section format string.
            function getProperFormatSection() {
                var fmt = format.split(";"),
                    result;
                if (amount < 0 && fmt[1]) {
                    result = fmt[1];
                    formatSectionUsed = 1;
                } else if (amount === 0) {
                    if (fmt[2]) formatSectionUsed = 2;
                    result = fmt[2] || fmt[0];
                } else {
                    result = fmt[0];
                }
                // remove obsolete literals from the literals array after format section split
                if (literals.length && fmt.length > 1) {
                    var counts = [], i, l;
                    for (i = 0, l = fmt.length; i < l; i++)
                        counts.push((fmt[i].match(LITERAL_PLACEHOLDER_REGEXP) || []).length);
                    for (i = 0, l = formatSectionUsed; i < l; i++)
                        literals.splice(0, counts[i]);
                    literals.splice(counts[formatSectionUsed], literals.length - counts[formatSectionUsed]);
                }
                return result;
            }

            // replace literals with placeholders for start
            format = format.replace(LITERAL_REGEXP, replaceLiterals),
                // split number according to decimal index when found
                integer = Math.abs(amount).toString().split(DOT),
                fraction = integer[1] ? integer[1] : "";
            // take proper format according to positive, zero or negative amount ( when specified )
            format = getProperFormatSection(amount, format);
            // find groups if any
            format = format.replace(GROUP_REGEXP, replaceGroups);
            // other commas found might be literals or number scaling
            // when directly before the decimal separator position
            // so proper solution would be to insert them into literals array,
            // or scale the number & delete the comma when scaling operator
            // TODO : for now, let's ignore these cases and remove remaining commas
            var formatWithPlaceholders = format.replace(/\,/g, "");
            // get the raw number format without placeholders
            format = formatWithPlaceholders.replace(LITERAL_PLACEHOLDER_REGEXP, "");
            // check for literals-only format
            var literalsOnly = Boolean(!format.length && formatWithPlaceholders.length);
            // format the raw number ( integer & fraction part )
            var decimalIndex = format.indexOf(DOT),
                zeroIndex = -1,
                sharpIndex = -1,
                hasZero = false,
                hasSharp = false;
            if (decimalIndex > -1) {
                zeroIndex = format.lastIndexOf(ZERO) - decimalIndex;
                sharpIndex = format.lastIndexOf(SHARP) - decimalIndex;
                hasZero = zeroIndex > -1;
                hasSharp = sharpIndex > -1;
                precision = fraction.length;
                if (!hasZero && !hasSharp) {
                    format = format.substring(0, decimalIndex) + format.substring(decimalIndex + 1);
                    decimalIndex = -1;
                    precision = 0;
                } if (hasZero && zeroIndex > sharpIndex) {
                    precision = zeroIndex;
                } else if (sharpIndex > zeroIndex) {
                    if (hasSharp && precision > sharpIndex)
                        precision = sharpIndex;
                    else if (hasZero && precision < zeroIndex)
                        precision = zeroIndex;
                }
                amount = round(amount, precision > -1 ? precision : 0);
            } else
                amount = round(amount);
            // split rounded string value again
            integer = (literalsOnly ? "" : amount).replace("-", "").split(DOT);
            fraction = integer[1] ? integer[1] : "";
            integer = integer[0];
            // check groups
            hasGroups = Boolean(hasGroups && groupSeparator && groupSizes && groupSizes.length);
            // combine groups & literals addition in one loop ?
            var formatBeforeDot = formatWithPlaceholders.split(DOT),
                formatAfterDot = formatBeforeDot[1] ? formatBeforeDot[1] : "";
            formatBeforeDot = formatBeforeDot[0];
            zeroIndex = formatBeforeDot.indexOf(ZERO);
            var i1 = formatBeforeDot.length - 1,
                i2 = integer.length - 1,
                c1, c2,
                getChars = function () {
                    c1 = formatBeforeDot.charAt(i1);
                    c2 = integer.charAt(i2);
                },
                groupSizeIndex = -1,
                groupCounter,
                getGroupSize = function () {
                    if (!hasGroups) return;
                    groupCounter = 0;
                    if (groupSizeIndex < groupSizes.length - 1) {
                        groupSizeIndex++;
                        groupSize = groupSizes[groupSizeIndex];
                    }
                },
                updateGroupCounter = function () {
                    if (!hasGroups) return;
                    if (groupCounter === groupSize) {
                        value = groupSeparator + value;
                        getGroupSize();
                    }
                    groupCounter++;
                };
            // format integer part - going from right to left here
            value = "";
            if (formatBeforeDot !== "") {
                getChars();
                getGroupSize();
                while (i1 > -1 || i2 > -1) {
                    switch (c1) {
                        case LITERAL_PLACEHOLDER:
                            // literal placeholders are just copied to the resulting string in this step
                            value = LITERAL_PLACEHOLDER + value;
                            i1--;
                            break;
                        case ZERO:
                        case SHARP:
                            if ((i1 > zeroIndex || c1 === ZERO) && c2 === "") c2 = ZERO;
                            if (c2 !== "") {
                                // append group separator when prepending numeric chars and the amount
                                // of written numeric chars just went over current group size
                                updateGroupCounter();
                                // for zeros, always copy numeric char from the integer part or zero when not available
                                // for sharp copy numeric char only if available
                                value = c2 + value;
                            }
                            i1--;
                            if (i2 > -1) i2--;
                            break;
                        case "":
                            // copy remaining chars at start of integer part
                            if (c2 !== "") {
                                updateGroupCounter();
                                value = c2 + value;
                            }
                            if (i2 > -1) i2--;
                            break;
                    }
                    getChars();
                }
            }
            amount = value;
            // format decimals part
            if (formatAfterDot !== "") {
                zeroIndex = formatAfterDot.lastIndexOf(ZERO);
                var l1 = formatAfterDot.length,
                    l2 = fraction.length;
                i1 = 0;
                i2 = 0;
                getChars = function () {
                    c1 = formatAfterDot.charAt(i1);
                    c2 = fraction.charAt(i2);
                };
                value = "";
                getChars();
                getGroupSize();
                while (i1 < l1 || i2 < l2) {
                    switch (c1) {
                        case LITERAL_PLACEHOLDER:
                            // literal placeholders are just copied to the resulting string in this step
                            value += LITERAL_PLACEHOLDER;
                            i1++;
                            break;
                        case ZERO:
                        case SHARP:
                            if ((i1 < zeroIndex || c1 === ZERO) && c2 === "") c2 = ZERO;
                            // for zeros, always copy numeric char from the integer part or zero when not available
                            // for sharp copy numeric char only if available
                            if (c2 !== "") value += c2;
                            i1++;
                            if (i2 < l2) i2++;
                            break;
                        case "":
                            // copy remaining chars at end of fraction part
                            if (c2 !== "") value += c2;
                            if (i2 < l2) i2++;
                            break;
                    }
                    getChars();
                }
                // append to amount; decimal separator should be used only when some
                // numeric chars were appended, means fraction string was set,
                // otherwise only literal(s) will be appended, if any
                amount += (fraction !== "" ? decimalSeparator : "") + value;
            }
            // replace the literals
            i1 = 0;
            amount = amount.replace(LITERAL_PLACEHOLDER_REGEXP, function () {
                var out = (literals.length > i1) ? literals[i1] : "";
                i1++;
                return out;
            });
            // trim the result
            amount = $.trim(amount);
            return formatWithPattern(pattern, amount, symbol, amountCssClass, symbolCssClass);
        }

        var currency = formatCurrency(number, oriCurrency, amountCssClass, symbolCssClass);
        if (!oriCurrency.doubleCurrency) return currency;
        // double currency is always placed as first in the resulting string
        // is the exchange rate is missing, we use 1 ( same amount ) as a fallback
        // TODO : maybe some additional checking should be done for rate or some message somewhere
        var doubleCurrency = formatCurrency(
            number * (oriCurrency.doubleCurrency.rate || 1), oriCurrency.doubleCurrency,
            dcAmountCssClass, dcSymbolCssClass
        );
        return doubleCurrency + doubleCurrencyDelimiter + currency;
    }

    /**
     * Updates kendo.toString() method with new ori currency format.
     * @param {} value Value to be serialized to text.
     * @param {} format Standard or custom format. Now supports "oc" as ori currency format
     * optionally containing also decimal precision, like "oc3" etc.
     * @param {} culture Optional culture. When empty, current culture will be loaded.
     * Please note that for other than the current culture, the additional ori currency
     * info will probably not be set. When specifying optional CSS classes and current
     * culture should be used, provide undefined or null value for culture parameter.
     * @param {} amountCssClass Optional CSS class for formatting the amount value text.
     * @param {} symbolCssClass Optional CSS class for formatting the currency symbol text.
     * @param {} dcAmountCssClass Same as amountCssClass, but used only when double currency is on.
     * @param {} dcSymbolCssClass Same as symbolCssClass, but used only when double currency is on.
     * @param doubleCurrencyDelimiter The custom delimiter to be used instead of default for double currency, but used only when double currency is on.
     * @returns {} Formatted string optionally containing double currency
     * and / or additional CSS formatting classes' spans for the "oc" format.
     */
    function toString(
        value, format, culture,
        amountCssClass, symbolCssClass,
        dcAmountCssClass, dcSymbolCssClass,
        doubleCurrencyDelimiter
    ) {
        if (!getOriCurrencyFormatPrecision(format) || typeof value != "number")
            return oldToString(value, format, culture);
        return formatOriCurrency(
            value, format, culture,
            amountCssClass, symbolCssClass,
            dcAmountCssClass, dcSymbolCssClass,
            doubleCurrencyDelimiter
        );
    }

    /**
     * Same as original Kendo method, have to repeat to have different reference to toString().
     */
    function format(fmt) {
        var values = arguments,
            FORMAT_REGEXP = /\{(\d+)(:[^\}]+)?\}/g;
        return fmt.replace(FORMAT_REGEXP, function (match, index, placeholderFormat) {
            var value = values[parseInt(index, 10) + 1];
            return toString(value, placeholderFormat ? placeholderFormat.substring(1) : "");
        });
    }

    // updated method reference
    var oldPlugin = kendo.ui.plugin;

    /**
     * Updated plugin method which exports global getters for known widget types also to kendo namespace.
     * Uses the undocumented $(...).getKendoDropDownList() approach, which is exported to methods like
     * kendo.getDropDownList(...). Similar way, the instances of Kendo widgets can now be created with
     * kendo.createDropDownList(selector, options) instead of $(selector).kendoDropDownList(options).
     */
    function plugin(widget, register, prefix) {
        oldPlugin(widget, register, prefix);
        prefix = prefix || "";
        var name = widget.fn.options.name,
            getter = "get" + prefix + name,
            ctor = "create" + prefix + name;
        name = "kendo" + prefix + name;
        kendo[getter] = function (selector) {
            return $(selector).data(name);
        };
        kendo[ctor] = function (selector, options) {
            var $element = $(selector);
            if (!$element.length) {
                throw new Error("No element found for selector " + selector + " for component " + name);
            }
            var instance = kendo.findWidgetInstance($element, true);
            if (instance) {
                var instanceType = instance.options.name;
                if (("kendo" + prefix + instanceType) === name) {
                    // in setOptions function options are not optional so we will call it only if we have options
                    if (options) {
                        instance.setOptions(options);
                    }
                    return instance;
                    // creating widget on element with some other widget - excluding validator - is forbidden
                } else if (name !== "kendoValidator") {
                    throw new Error(
                        "Existing Kendo widget instance of type " + instanceType +
                        " found on specified element " + kendo.describeElement($element)
                    );
                }
            }
            instance = $element[name](options).data(name);
            if (!instance) {
                throw new Error("Kendo widget " + name + " wasn't instantiated correctly.");
            }
            return instance;
        }
    }

    // publish needed methods into global kendo namespace
    $.extend(true, kendo, {
        boundingRect: boundingRect,
        decode: decode,
        describeElement: describeElement,
        elementOptions: elementOptions,
        findWidgetInstance: findWidgetInstance,
        findWrapper: findWrapper,
        format: format,
        getGenericInit: getGenericInit,
        getInputValue: getInputValue,
        getUpdatedWidgetOptions: getUpdatedWidgetOptions,
        isCrossDomainIframe: isCrossDomainIframe(),
        isElementInViewport: isElementInViewport,
        isIframe: isIframe(),
        isChildOf: isChildOf,
        moveCustomStylesToWrapper: moveCustomStylesToWrapper,
        moveFunctionalityToWrapper: moveFunctionalityToWrapper,
        moveRwdDataToWrapper: moveRwdDataToWrapper,
        moveStateStylesToWrapper: moveStateStylesToWrapper,
        nearest: nearest,
        parseBoolean: parseBoolean,
        placeholderLabel: placeholderLabel,
        placeholderVisibility: placeholderVisibility,
        round: kendo._round,
        scrollProps: scrollProps,
        toggleHoverOnWrapper: toggleHoverOnWrapper,
        toString: toString,
        updateJsonResult: updateJsonResult,
        updateOriCurrency: updateOriCurrency,
        updatePlaceholderLogic: updatePlaceholderLogic,
        widgetInstanceEx: widgetInstanceEx
    });
    kendo.ui.plugin = plugin;

    // #endregion global Kendo extensions

    // #region Class extensions

    /**
     * Appends debug functionality into Kendo classes. Debug info levels are :
     * 1 - error
     * 2 - warning
     * 3 - info
     * All other levels are displayed as default log messages in console without
     * icon etc. Default debug level for Kendo "class" is set to warnings and
     * must be overriden when for example traces should be displayed.
     */
    if (Class) {

        var cp = Class.prototype;

        /**
         * _initOptions() is used only for a few simple classes.
         * More complex components usually use init().
         */
        var oldInitOptions = cp._initOptions;
        cp._initOptions = function (options) {
            var self = this,
                level = parseInt(getStoredSetting(self.debugCookieName()) || WARNING, 10);
            oldInitOptions.call(self, options);
            self.options = $.extend({}, defaultWidgetOptions, { debugLevel: level }, self.options);
        };

        /**
         * Debug cookie name specified to get / set max debug level on client.
         */
        cp.debugCookieName = function () {
            var opt = this.options || {},
                name = opt.name || "Class";
            return "debugKendo" + name.substr(0, 1).toUpperCase() + name.substr(1);
        };

        /**
         * Maximum debug messages level. Filters debug messages displayed in
         * console. Set to INFO for displaying also trace debug messages.
         * Unfortunatelly
         */
        cp.debugLevel = function () {
            var level = WARNING;
            if (this.options) {
                if (typeof this.options.debugLevel != "undefined")
                    level = this.options.debugLevel;
                else
                    this.options.debugLevel = level;
            }
            return level;
        };

        /**
         * Log prefix for debug messages functionality.
         */
        cp.logPrefix = function () {
            var opt = this.options || {};
            return formatDate(new Date(), opt.fullDates) + " " + (opt.name ? (opt.name + " : ") : "");
        }

        /**
         * Displays a message in JS console.
         */
        cp.print = function (what, args, level) {
            var self = this,
                opt = self.options || {};
            if (isNaN(level)) level = INFO;
            if (level > self.debugLevel()) return;
            what = self.logPrefix() + what;
            switch (opt.outputType) {
                case OUTPUT_NONE:
                    break;
                case OUTPUT_ALERTS:
                    alert(what);
                    break;
                default:
                    if (!window.console) return;
                    if (!args) args = [];
                    if (!$.isArray(args)) args = [args];
                    args.unshift(what);
                    switch (level) {
                        case ERROR: console.error.apply(console, args); break;
                        case WARNING: console.warn.apply(console, args); break;
                        case INFO: console.info.apply(console, args); break;
                        default: console.log.apply(console, args);
                    }
                    break;
            }
        };

        /**
         * Error level message output. Use probably rather throw than this.
         */
        cp.error = function () {
            var args = [].slice.apply(arguments);
            if (!args.length) return;
            var what = args.shift();
            this.print(what, args, ERROR);
        };

        /**
         * Warning level message output.
         */
        cp.warning = function () {
            var args = [].slice.apply(arguments);
            if (!args.length) return;
            var what = args.shift();
            this.print(what, args, WARNING);
        };

        /**
         * Info ( trace ) level message output.
         */
        cp.info = function () {
            var args = [].slice.apply(arguments);
            if (!args.length) return;
            var what = args.shift();
            this.print(what, args, INFO);
        };

        /**
         * Simple log message output.
         */
        cp.log = function () {
            var args = [].slice.apply(arguments);
            if (!args.length) return;
            var what = args.shift();
            this.print(what, args, LOG);
        };

        /**
         * Tries to describe the specified element for better identification.
         */
        cp.describeElement = kendo.describeElement;

        /**
         * Tries to describe the specified event for better identification.
         */
        cp.describeEvent = function (event, context) {
            context = context || "";
            if (context) context = "event in context " + context;
            if (!event) return context + " - ( undefined event )";
            var showActive = false;
            switch (event.type) {
                case "click":
                case "focus":
                case "blur":
                    showActive = true;
            }
            return context +
                "\n\ttype : " + event.type +
                ",\n\ttarget : " + describeElement(event.target) +
                ",\n\tcurrent target : " + describeElement(event.currentTarget) +
                (
                    event.relatedTarget ? "\n\tevent.relatedTarget : " +
                        describeElement(event.relatedTarget) : ""
                ) +
                (
                    showActive ? "\n\tdocument.activeElement : " +
                        describeElement(document.activeElement) : ""
                );
        };

        /**
         * Returns the original data attribute name with hyphens from the camelized
         * data key name.
         */
        cp.dataKeyToAttr = function (key) {
            return key ?
                "data-" + key.replace(/[A-Z]/g, function (match) {
                    return "-" + match.toLowerCase();
                }) : "";
        };

    }

    // #endregion Class extensions

    // #region Observable extensions

    if (Observable) {

        var op = Observable.prototype,
            preventDefault = function () {
                this._defaultPrevented = true;
            },
            isDefaultPrevented = function () {
                return this._defaultPrevented === true;
            };

        /**
         * Overrides the trigger method so that each created event object has also type property defined.
         */
        op.trigger = function (eventName, e) {
            var self = this,
                events = self._events ? self._events[eventName] : null,
                idx,
                length;
            if (events) {
                e = e || {};
                e.originalType = e.type; // this is newer :-P
                e.type = eventName; // this is new ;o)
                e.sender = self;
                e._defaultPrevented = false;
                e.preventDefault = preventDefault;
                e.isDefaultPrevented = isDefaultPrevented;
                events = events.slice();
                for (idx = 0, length = events.length; idx < length; idx++)
                    events[idx].call(self, e);
                return e._defaultPrevented === true;
            }
            return false;
        }

        /**
         * Adds alias methods for connecting and disconnecting event handlers according to current events list.
         */
        op.createEventMethods = function () {
            var self = this;

            if (!self.events || !self.events.length) {
                return;
            }

            function createMethod(key) {
                var currentName = key.substring(0, 1).toUpperCase() + key.substring(1),
                    methodName = "bind" + currentName;
                if (typeof self[methodName] != "function") {
                    self[methodName] = function (handler, one) {
                        self.bind(key, handler, one);
                        return self;
                    }
                }
                methodName = "unbind" + currentName;
                if (typeof self[methodName] != "function") {
                    self[methodName] = function (handler) {
                        self.unbind(key, handler);
                        return self;
                    }
                }
            }

            for (var key in self.events) {
                if (self.events.hasOwnProperty(key)) {
                    createMethod(self.events[key]);
                }
            }
        }

    }

    // #endregion Observable extensions

    // #region Widget extensions

    /**
     * Tooltip / title description update for Widget.
     */
    if (Widget) {

        var wp = Widget.prototype,
            oldWidgetInit = wp.init;

        wp.activateLabel = activateLabel;

        /**
         * init() includes additional default options.
         * TODO : check individual updated options in particular widgets
         */
        wp.init = function (element, options) {
            var self = this,
                level = parseInt(getStoredSetting(self.debugCookieName()) || WARNING, 10);
            self.options = $.extend({}, defaultWidgetOptions, self.options, { debugLevel: level });
            oldWidgetInit.call(self, element, options);
            // activate corresponding label to focus visible element
            self.activateLabel();
            // publish new event binder methods
            self.createEventMethods();
        };

        /**
         * Initializes / updates description UI according to current settings.
         * If the descriptionUiType parameter is set, the value is copied into
         * widget's options. Otherwise existing value in options is taken, or
         * data-descr-type attribute on widget as a fallback.
         * For checkbox there is a hack with hidden input with false value and
         * same name next to the original input, so that the value is always sent
         * to server. The hidden control must immediatelly follow the original input.
         */
        wp.descriptionUi = function (descriptionUiType) {
            var self = this;
            if (!self.element.length) return;
            descriptionUiType = descriptionUiType || self.options.descriptionUi ||
                self.element.data(ATTR_DESCR_UI_TYPE) || DESCR_UI_ICON;
            // hack for filter elements (since version 2017.1.223 filters have title)
            if (self.element.parents(".k-filter-menu").length > 0) descriptionUiType = DESCR_UI_TITLE;
            // end hack
            self.options.descriptionUi = descriptionUiType;
            var descrIconClass = self.options.descriptionIconCssClass || DESCR_ICON;
            self.options.descriptionIconCssClass = descrIconClass;
            var validationUiType = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE),
                fieldId = (self.element.attr(ID) || self.element.attr("name") || ""),
                template = kendo.template(self.options.templates[
                    WIDGET_DESCRIPTION_TEMPLATE_PREFIX + descriptionUiType
                ]),
                data = {
                    message: kendo.decode(self.options.titleText),
                    control: (fieldId ? ' for="' + fieldId + '"' : ''),
                    descrIconClass: descrIconClass
                },
                markup = template(data),
                duration = self.options.duration || DEFAULT_DURATION,
                $wrapper = kendo.findWrapper(self.element),
                hasWrapper = ($wrapper && $wrapper.length),
                $outer = hasWrapper ? $wrapper : self.element,
                invalid = kendo.parseBoolean(self.element.attr(ATTR_INVALID)),
                icon = "." + descrIconClass,
                $lbl = (hasWrapper ? $wrapper : self.element.parent()).find(icon);
            $outer.removeClass(WITH_DESCR_ICON);
            if ($lbl.length) {
                kendo.removeElementTooltips($lbl);
                $lbl.remove();
            }
            if ($outer.length && (!invalid || validationUiType !== VAL_UI_TOOLTIP))
                kendo.removeElementTooltips($outer);
            if ($outer.length && (!invalid || validationUiType !== VAL_UI_TITLE)) {
                self.element.removeAttr(ATTR_TITLE);
                if (hasWrapper) $wrapper.removeAttr(ATTR_TITLE);
            }
            if (!self.options.titleText) return;
            switch (descriptionUiType) {
                case DESCR_UI_TITLE:
                    // keep description as title
                    if (!invalid || validationUiType !== VAL_UI_TITLE) {
                        self.element.attr(ATTR_TITLE, markup);
                        if (hasWrapper) $wrapper.attr(ATTR_TITLE, markup);
                    }
                    break;
                case DESCR_UI_TOOLTIP:
                    // make description as tooltip on whole widget
                    if (!invalid || validationUiType !== VAL_UI_TOOLTIP)
                        kendo.applyElementTooltips($outer, { content: markup, duration: duration });
                    break;
                case DESCR_UI_ICON:
                    // as previous, tooltip icon is shown with description
                    // tooltip applied
                    if (!invalid || validationUiType !== VAL_UI_ICON) {
                        $lbl = $(markup);
                        var $titleIcon = $lbl.is(icon) ? $lbl : $lbl.find(icon);
                        if (hasWrapper) {
                            $lbl.appendTo($wrapper);
                        }
                        // apply Kendo tooltip logic when present
                        kendo.applyElementTooltips($titleIcon, { content: data.message, duration: duration });
                        // TODO : description icon should be hidden when the widget
                        // is invalid, or not appended to widget at all
                        // TODO : actually, this could be parametrized in options
                    }
                    $outer.addClass(WITH_DESCR_ICON);
                    break;
            }
        };

        wp.appendEvents = appendEvents;

    }

    // #endregion Widget extensions

    kendo.updated = true;

})(window.kendo.jQuery);
